<template>
	<div>
		<MainHeader />

		<b-container id="image-container" :style="creationBackground" fluid class="p-3 p-md-4 p-lg-5 text-white bg-cover text-shadow">
			<h1 class="mb-5 text-shadow">{{ title }}</h1>
			<p class="h2 mb-4">{{ text }}</p>
			<p class="h3 mb-4">À partir de {{ services.creation.price.initial }}{{ services.currency }}</p>
			<b-button to="/creation/commande" size="lg" class="btn-responsive">Création en ligne</b-button>
		</b-container>

		<b-container fluid class="bg-light p-5">
			<b-row class="justify-content-center">
				<Pack
				v-for="(pack, index) in services.creation.packs"
				:key="index"
				:index="index"
				:pack="pack"  />
			</b-row>
		</b-container>

		<b-container fluid class="p-3 p-md-4 p-lg-5">
			<b-row class="mb-5">
				<b-col cols="12" md="">
					<b-row>
						<b-col>
							<h2>{{ title }}</h2>
						</b-col>
					</b-row>

					<b-row>
						<b-col>
							<p class="h3 text-black-50">Un expert s'occupe de tout jusqu'au Kbis !</p>
						</b-col>
					</b-row>
				</b-col>

				<b-col cols="12" md="auto">
					<b-button to="/creation/commande" variant="primary">Création express</b-button>
				</b-col>
			</b-row>

			<b-row class="mb-5" cols="1" cols-md="2">
				<b-col class="mb-5 mb-md-0">
					<p>
						Créer son entreprise peut rapidement s'avérer le parcours du combattant : <strong>rédaction des statuts juridiques</strong>, <strong>formalités auprès du greffe</strong>, <strong>dépôt du capital à la banque</strong>, <strong>immatriculation</strong>, <strong>publication d'une annonce légale</strong>...
						<br><br>
						Toutes ces tâches prennent du temps, et s'aventurer à les réaliser seul peut réserver de mauvaises surprises. En effet, un mauvais choix au départ peut s'avérer coûteux pour un entrepreneur.
						<br><br>
						{{ appName }} simplifie et accélère la <strong>création de votre entreprise</strong> !
					</p>
				</b-col>

				<b-col>
					<p>
						{{ appName }} a créé une <strong>offre clé en main</strong> pensée pour les créateurs d'aujourd'hui et de demain.
						<br><br>
						Un expert en création d'entreprise vous accompagne durant toute la phase de <strong>création de votre société</strong> :
					</p>

					<ul class="p-0">
						<li class="d-flex align-items-center">
							<img src="../../assets/images/icons/tick/tick.svg" alt="Flèche rouge vers la droite" width="20" height="20" class="mr-2 mb-3">
							<p>Rendez-vous téléphonique de création</p>
						</li>

						<li class="d-flex align-items-center">
							<img src="../../assets/images/icons/tick/tick.svg" alt="Flèche rouge vers la droite" width="20" height="20" class="mr-2 mb-3">
							<p>Réalisation du dossier de création</p>
						</li>

						<li class="d-flex align-items-center">
							<img src="../../assets/images/icons/tick/tick.svg" alt="Flèche rouge vers la droite" width="20" height="20" class="mr-2 mb-3">
							<p>Réalisation des démarches administratives</p>
						</li>
					</ul>
				</b-col>
			</b-row>

			<b-row cols="1" cols-md="2">
				<b-col class="mb-5 mb-md-0">
					<h3>Fonctionnement</h3>
					<p>
						Un expert {{ appName }} vous appelle et vous pose un ensemble de questions dans le but de réaliser avec vous le <strong>dossier d'immatriculation</strong> de votre entreprise. <strong>Dénomination sociale</strong>, <strong>capital</strong>, <strong>associés</strong> : vous n'avez qu'à répondre à quelques questions et s'il s'occupe du reste.
						<br><br>
						Des particularités relatives à votre activité ? Parlez-en à votre conseiller qui saura vous indiquer les marches à suivre.
					</p>
				</b-col>

				<b-col>
					<h3>Formalités & immatriculation</h3>
					<p>
						Une fois votre dossier intégralement complété, vous recevrez votre <strong>extrait Kbis</strong> directement par courrier. Bravo, vous êtes immatriculé(e) !
						<br><br>
						Ne vous souciez plus des formalités et déléguez la création de votre entreprise à un expert qui se chargera de tout :
					</p>

					<ul class="p-0">
						<li class="d-flex align-items-center">
							<img src="../../assets/images/icons/tick/tick.svg" alt="Flèche rouge vers la droite" width="20" height="20" class="mr-2 mb-3">
							<p>Constitution du dossier de création</p>
						</li>

						<li class="d-flex align-items-center">
							<img src="../../assets/images/icons/tick/tick.svg" alt="Flèche rouge vers la droite" width="20" height="20" class="mr-2 mb-3">
							<p>Gestion des formalités administratives</p>
						</li>

						<li class="d-flex align-items-center">
							<img src="../../assets/images/icons/tick/tick.svg" alt="Flèche rouge vers la droite" width="20" height="20" class="mr-2 mb-3">
							<p>Publication de l'annonce légale (frais inclus)</p>
						</li>

						<li class="d-flex align-items-center">
							<img src="../../assets/images/icons/tick/tick.svg" alt="Flèche rouge vers la droite" width="20" height="20" class="mr-2 mb-3">
							<p>Immatriculation au Greffe (frais inclus)</p>
						</li>
					</ul>
				</b-col>
			</b-row>
		</b-container>

		<b-container fluid class="bg-light p-5">
			<b-row class="mb-5">
				<b-col class="text-center">
					<h2>Recevez votre extrait Kbis en 48h chrono</h2>
				</b-col>
			</b-row>

			<b-row cols="1" cols-md="3" class="overflow-hidden">
				<b-col class="text-center" data-aos="fade-right">
					<img src="../../assets/images/icons/creation/solution.svg" alt="Pièces de puzzle assemblées" width="100" height="100" class="mb-5" />
					<p>Choisissez la forme juridique de votre choix : SARL, SAS, SCI...</p>
				</b-col>

				<b-col class="text-center" data-aos="fade-up">
					<img src="../../assets/images/icons/creation/url.svg" alt="Planète terre représentant internet entourée 4 points" width="100" height="100" class="mb-5" />
					<p>Renseignez en moins de 2 minutes un formulaire 100% en ligne</p>
				</b-col>

				<b-col class="text-center" data-aos="fade-left">
					<img src="../../assets/images/icons/creation/business-and-finance.svg" alt="Manuscrit déplié sur lequel est inscrit une ampoule représentant une idée" width="100" height="100" class="mb-5" />
					<p>Un expert vous rappelle, constitue votre dossier et réalise les formalités</p>
				</b-col>
			</b-row>
		</b-container>

		<b-container fluid class="p-5">
			<b-row class="mb-3">
				<b-col class="text-center">
					<h2>Créez votre entreprise maintenant</h2>
				</b-col>
			</b-row>

			<b-row class="mb-3">
				<b-col class="text-center">
					<b-button to="/creation/commande" size="lg" class="btn-responsive">Créer mon entreprise</b-button>
				</b-col>
			</b-row>

			<b-row>
				<b-col class="text-center">
					<p class="text-black-50">Confiez la création de votre société à un expert. Kbis en 48h chrono</p>
				</b-col>
			</b-row>
		</b-container>

		<Sidebar />

		<MainFooter />
	</div>
</template>

<script>
	import { mapState } from 'vuex'

	import MainHeader from '../../components/MainHeader.vue'
	import Sidebar from '../../components/Sidebar.vue'
	import MainFooter from '../../components/MainFooter.vue'
	import Pack from '../../components/creation/Pack.vue'

	export default {
		components: {
			MainHeader,
			Sidebar,
			MainFooter,
			Pack
		},
		data() {
			return {
				title: 'Créer ou transférer votre entreprise en toute sérénité !',
				text: 'Recevez votre Kbis en 48H*'
			}
		},
		computed: {
			creationBackground() {
				return 'background-image: url('+this.services.creation.img+')'
			},
			...mapState(['appName', 'services'])
		}
	}
</script>
